export default __webpack_public_path__ + "static/media/lgLogin.3c45d33a.png";